import { TranslationItemModel } from '@/shared/api/BaseAPI.model'

type toppingIngredientModel = {
  id: string
  unit: { id: string; quantity: number }
}

type toppingModel = {
  id?: string
  price: number
  // VAT rate in percent (0-100)
  taxRate?: number
  translations: TranslationItemModel[]
  dishCategoryIds: string[]
  ingredients?: toppingIngredientModel[]
  allergenIds?: string[]
}

type toppingPayloadModel = {
  price: number
  // VAT rate in percent (0-100)
  taxRate?: number
  translations: TranslationItemModel[]
  dishCategoryIds: string[]
}

type toppingPutPayloadModel = {
  toppingId: string
  toppingPayload: toppingPayloadModel
}
type toppingResponseModel = {
  price: number
  // VAT rate in percent (0-100)
  taxRate?: number
  translations: TranslationItemModel[]
  dishCategoryIds: string[]
}
type toppingsResponseModel = toppingModel[]

enum QUERY {
  TOPPINGS = 'toppings'
}
export { QUERY }

export type {
  toppingModel,
  toppingIngredientModel,
  toppingPayloadModel,
  toppingPutPayloadModel,
  toppingResponseModel,
  toppingsResponseModel
}
